import { DatePickerProps, KeyboardDatePicker } from '@material-ui/pickers';
import { BaseKeyboardPickerProps } from '@material-ui/pickers/_shared/hooks/useKeyboardPickerState';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePickerToolbar from './KeyboardDatePickerToolbar';

export type SGSKeyboardDatePickerProps = BaseKeyboardPickerProps & DatePickerProps;

const SGSKeyboardDatePicker: React.FC<SGSKeyboardDatePickerProps> = ({ ...props }) => {
    const { t } = useTranslation();
    return (
        <KeyboardDatePicker
            {...props}
            ToolbarComponent={DatePickerToolbar}
            views={['year', 'month', 'date']}
            cancelLabel={t('global.cancel')}
            clearLabel={t('global.clear')}
            okLabel={t('global.ok')}
            todayLabel={t('global.today')}
        />
    );
};

export default SGSKeyboardDatePicker;
